import { RouteObject } from "react-router";
import { Redirect } from "src/router/helper/Redirect";
export const PresentationsRoutes: RouteObject[] = [
  {
    path: ":presentationId/present",
    async lazy() {
      const { ShowPresentation } = await import("common/components/ShowPresentation");
      return { element: <ShowPresentation analyticsData={{ category: "Presentation" }} /> };
    },
    async loader(args) {
      const { presentationPresentLoader } = await import("src/router/loaders/Orgs");
      return presentationPresentLoader(args);
    },
  },
  {
    path: "",
    async lazy() {
      const { PresentationsTab } = await import("jobs/Job/PresentationsTab");
      return { element: <PresentationsTab /> };
    },
    children: [
      {
        path: "dynamic",
        async lazy() {
          const { Dynamic } = await import("jobs/Job/PresentationsTab/Dynamic");
          return { element: <Dynamic /> };
        },
        shouldRevalidate: () => false,
        loader: async (args) => {
          const { jobPresentationsLoader } = await import("src/router/loaders/Jobs");
          return jobPresentationsLoader(args);
        },
        children: [
          {
            path: "",
            async loader(args) {
              const { dynamicPresentationsFolderLoader } = await import("src/router/loaders/Jobs");
              return dynamicPresentationsFolderLoader(args);
            },
          },
        ],
      },
      {
        path: "standard",
        async lazy() {
          const { Standard } = await import("jobs/Job/PresentationsTab/Standard");
          return { element: <Standard /> };
        },
        async loader(args) {
          const { presentationsFolderLoader } = await import("src/router/loaders/Jobs");
          return presentationsFolderLoader(args);
        },
      },
      {
        path: "",
        element: <Redirect to="standard" />,
      },
    ],
  },
];
